import { render, staticRenderFns } from "./ManageAccreditation.vue?vue&type=template&id=351ce47d&scoped=true&"
import script from "./ManageAccreditation.vue?vue&type=script&lang=js&"
export * from "./ManageAccreditation.vue?vue&type=script&lang=js&"
import style0 from "./ManageAccreditation.vue?vue&type=style&index=0&id=351ce47d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ce47d",
  null
  
)

export default component.exports